import { useTranslation } from "react-i18next";

import { Rule } from "../../types";
import { getSmimeActionState } from "pages/Rules/Form/context/ruleSelectors";

interface Props {
  rule: Rule;
}

export default function SmimeActionsDetails(props: Props) {
  const { rule } = props;
  const { t } = useTranslation("rules");
  const { smimeActions } = getSmimeActionState(rule);
  const actionsDetail = smimeActions
    .map(a => t(`smimeAction.${a}.label`))
    .join(" - ");

  return <div>{smimeActions.length ? actionsDetail : t("common:none")}</div>;
}
